import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

const useDocumentFilters = ({ defaultQuery, searchOnChange = false }) => {
  const [selectedFilter, setSelectedFilter] = useState('document_number');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [dateRange, setDateRange] = useState({ document_date: { type: 'date', start: null, end: null } });
  const [pagination, setPagination] = useState({ page: 0, size: 10 });

  useEffect(() => {
    // Reset pagination to page 0 when filters change
    setPagination((prev) => ({ ...prev, page: 0 }));
  }, [selectedFilter, selectedStatus, dateRange]);

  useEffect(() => {
    let query = buildQuery();
    setCurrentQuery(query);
  }, [selectedFilter, selectedStatus, dateRange, pagination]);

  useEffect(() => {
    if (!searchOnChange) return;

    const handler = debounce(() => {
      setCurrentQuery(buildQuery());
      // Reset pagination to page 0 when search changes
      setPagination((prev) => ({ ...prev, page: 0 }));
    }, 500);

    handler();
    return () => handler.cancel();
  }, [searchTerm]);

  const buildQuery = () => {
    const query = { ...defaultQuery, ...pagination };

    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    if (selectedStatus) {
      query.status = selectedStatus;
    }
    if (dateRange?.document_date?.start || dateRange?.document_date?.end) {
      const { start, end } = dateRange.document_date;
      const cleanDateObject = { ...(start && { start }), ...(end && { end }) };
      if (Object.keys(cleanDateObject).length) {
        query.document_date = JSON.stringify(cleanDateObject);
      }
    }

    return query;
  };
  const [currentQuery, setCurrentQuery] = useState(buildQuery());

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleStatusChange = (status) => setSelectedStatus(status);

  const handleDateRangeChange = (newDateRange) => setDateRange(newDateRange);

  const handlePaginationChange = (page, size) => setPagination({ page, size });

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
      setPagination((prev) => ({ ...prev, page: 0 }));
    }
  };

  return {
    selectedFilter,
    searchTerm,
    currentQuery,
    selectedStatus,
    dateRange,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    handleDateRangeChange,
    handlePaginationChange,
  };
};

export default useDocumentFilters;
